import { Navigate, Outlet, useNavigate } from "react-router-dom";
import useInactivityTimeout from "../../pages/useInactivityTimeout";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { _init_without_token_api } from "../../DAL/Login/Login";
import { useEffect, useState } from "react";
import { useAdminContext } from "../../hooks/UseAdminContext";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import AuthPrompt from "../dialogs/AuthPrompt";
import { allowedDomains } from "../../hooks/allowedDomains";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
const DefultLayout = () => {
  const { showDialog, handleStayLoggedIn, handleLogout, countdown } =
    useInactivityTimeout(300 * 1000, 270 * 1000);

  const classes = useStyles();
  const navigate = useNavigate();
  const {
    setAdminSetting,
    isAuthenticated,
    setIsAuthenticated,
    setIsOpenAuthModal,
  } = useAdminContext();

  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const get_setting_data = async () => {
    setIsLoading(true);
    const result = await _init_without_token_api();
    if (result.code == 200) {
      setAdminSetting(result?.maintenance_settings);
      setIsLoading(false);
      if (
        result?.maintenance_settings?.enable_developer_auth &&
        allowedDomains.includes(window.location.hostname)
      ) {
        // Only Show Auth Prompt if not already authenticated in this session
        if (sessionStorage.getItem("is_authenticated") === "true") {
          setIsAuthenticated(true);
        } else {
          setIsOpenAuthModal(true);
        }
      } else {
        setIsAuthenticated(true);
      }
      if (result?.maintenance_settings?.enable_maintenace_mode) {
        navigate("/under-maintenance", { replace: true });
      }
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    get_setting_data();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  if (!localStorage.getItem("code-verified")) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {isAuthenticated ? (
        <>
          <Outlet />
          <Dialog
            open={showDialog}
            aria-labelledby="inactivity-dialog-title"
            PaperProps={{
              style: {
                borderRadius: "12px",
                minWidth: "400px",
              },
            }}
          >
            <DialogTitle
              id="inactivity-dialog-title"
              sx={{
                p: "12px 24px",
                borderBottom: "1px solid #dee2e6",
                bgcolor: "#f8f9fa",
              }}
            >
              <h3 className="mb-0">Session Timeout Warning</h3>
            </DialogTitle>
            <DialogContent sx={{ p: 3, pt: 3 }} className="pt-3">
              <p className="mb-0">
                You will be logged out automatically in{" "}
                <strong>{countdown}</strong> seconds. Do you want to stay logged
                in or log out?
              </p>
            </DialogContent>
            <DialogActions
              sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}
            >
              <Button
                onClick={handleStayLoggedIn}
                variant="contained"
                color="primary"
                sx={{ mr: 1 }}
              >
                Stay Logged In
              </Button>
              <Button onClick={handleLogout} variant="contained" color="error">
                Logout
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <AuthPrompt />
      )}
    </>
  );
};

export default DefultLayout;
